var Inputs;
(function (Inputs) {
    Inputs["DURATION"] = "duration";
    Inputs["AMOUNT"] = "amount";
    Inputs["PERIOD"] = "period";
})(Inputs || (Inputs = {}));

export { Inputs };
